import CollectionSubtitle from "@components/Collection/CollectionSubtitle";
import LBox from "@components/LBox";
import LText from "@components/LText";
import type { CatalogCollectionType } from "@utils/player";
import React from "react";

export type CollectionTitlesProps = {
  id: string;
  onPress: () => void;
  screen: "library";
  subtitle?: string;
  subtitleNumberOfLines?: number;
  title?: string;
  type: CatalogCollectionType;
};

const CollectionTitles = ({
  onPress,
  subtitle,
  subtitleNumberOfLines,
  title,
}: CollectionTitlesProps) => {
  return (
    <LBox
      alignItems="center"
      gap="s2"
      justifyContent="space-between"
      paddingHorizontal="l1"
    >
      <LText textAlign="center" variant="collectionTitle" numberOfLines={2}>
        {title}
      </LText>
      <CollectionSubtitle
        numberOfLines={subtitleNumberOfLines}
        onPress={onPress}
        subtitle={subtitle}
      />
    </LBox>
  );
};

export default CollectionTitles;
